<div class="list-results-bar">
	<p class="list-results-bar__count">{{ resultsLabel() }}</p>

	@if (showDownload()) {
		<app-list-csv-export-button
			[disabled]="downloadDisabled()"
			[label]="downloadLabel()"
			[tooltip]="downloadTooltip()"
			(downloadClicked)="downloadClicked.emit()"
		/>
	}
</div>
